export default {
  getValidationMessage: (state) => (validationCode) => {
    return (state.validationMessages.find((m) => m.id == validationCode) || {})
      .name;
  },
  currentAcademicYear: (state) => {
    if (state.currentAcademicYear) {
      return state.currentAcademicYear;
    } else {
      return 'The current academic year is not available';
    }
  },
};
